export * from './get-template.directive';
export * from './get-template.model';
